module.exports = __webpack_public_path__ + "static/desktop/img/production-calendar.c8f7020e.png";